<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
		:footer="footer"
  >
    <template #TEST="{row}">
      <Select
        v-if="row"
        :placeholder="$t('select') + $t('currencyName')"
        @on-change="SelChange"
        v-model="row.currency_id"
        filterable
      >
        <Option
          v-for="(option, index) in options"
          :value="option.id"
          :key="index"
          :disabled="option.disabled"
          >{{ option.code }}</Option
        >
      </Select>
    </template>
		
  </cTable>
</template>

<script>
import {
  getList,
  add,
  del,
  update,
  getConfig,
	cost_classify,
	cost_expense_item,
	createBill,
	createDeliveryBill,
	clearance_fee,
	create_tag,
	preview
} from "@/api/cost/extractCost";
import {
	log,
} from "@/api/finance/channelCost";
import { getAgent } from "@/api/tracker/agent";
import cTable from "@/base/common/index";
import { getCurrency } from "@/api/finance/currency";
import { getSelectType } from "@/api/public";
import { getAllClient } from "@/api/user/client";
export default {
  name: "extractCost",
  components: {
    cTable
  },
  data() {
    let that = this;
    return {
      options: [],
			summary:[],
      methods: {
        list: getList,
        del,
        add,
        update,
        getCurrency,
				log,
				cost_classify,
				cost_expense_item,
				createBill,
				getAllClient,
				createDeliveryBill,
				clearance_fee,
				create_tag,
				preview,
				afterHandleList:({data})=>{
					this.summary = data.summary || []
					this.$nextTick(()=>{
						this.$refs['table'].handleResize()
					})
				}
      },
      config: {
        height: 630
      },
			footer:{
				render:(h)=>{
					return h('div',{style:'text-align:right'},Object.keys(this.summary).map(t=>h('span',{style:'margin-left:10px;'},[h('span',{style:'margin-right:3px;color:red'},t+':'),h('span',{},this.summary[t])])))
				}
			},
      modals: {
				createDeliveryBill:{
					type:'add',
					methods: {
					  ok({ row, close }) {
					    this.$page
					      .handleRequestMethods("createDeliveryBill", row, true)
					      .then(res => {
					        this.$page.getList();
					        close();
					      });
					  }
					},
					config: {
						title:this.$t('createDeliveryBill'),
					  modalBind: {
					    width: 600,
					    draggable: true,
					  },
					  formBind: {
					    labelWidth: 140
					  },
					  rowBind: {
					    gutter: 16,
					    style: {
					      marginBottom: "20px"
					    }
					  },
						rules:{
							type: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change",
							    type: "number"
							  }
							],
							bill_name: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change",
							  }
							],
							agent_id: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change",
							    type: "number"
							  }
							],
							airway_number: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change",
							  }
							],
						}
					},
					grid: [
					  {
							bill_name: 24,
					  },
						{
							type:24,
						},
						{
							agent_id:24,
						},
						{
							airway_number:24,
						},
						{
							remarks:24,
						}
					],
					fields: [
						{
						  name: () => this.$t("type"),
						  key: "type",
						  component: "Select",
						  placeholder() {
						    return this.$t("enter") + this.$t("type");
						  },
						  options: [
								{label:this.$t('apod'),value:2},
								{label:this.$t('unapod'),value:1}
							],
						},
					  {
					    name: () => this.$t("b2bName"),
					    key: "bill_name",
					    component: "Input",
					    placeholder() {
					      return this.$t("enter") + this.$t("b2bName");
					    }
					  },
						{
						  name: () => this.$t("agentName"),
						  key: "agent_id",
						  component: "Select",
						  placeholder() {
						    return this.$t("enter") + this.$t("agentName");
						  },
						  options: [],
							config: { label: "agent_name", value: "id" },
							methods:{
								list({field}){
									getAgent().then(res=>{
										if(res.data.status){
											field.options = res.data.payload.rows
										}
									})
								}
							}
						},
						{
						  name: () => this.$t("order_number"),
						  key: "airway_number",
						  component: "Input",
						  bind: {
						    type: "textarea",
						    rows: 2
						  },
						  placeholder() {
						    return this.$t("enter") + this.$t("order_number");
						  }
						},
						{
						  name: () => this.$t("Remarks"),
						  key: "remarks",
						  component: "Input",
						  bind: {
						    type: "textarea",
						    rows: 2
						  },
						  placeholder() {
						    return this.$t("enter") + this.$t("Remarks");
						  }
						}
					]
				},
				createBill:{
					type:'add',
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("createBill", row, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
						title:this.$t('createBill'),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 140
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
          },
          grid: [
            {
							bill_name: 24,
            },
						{
							rate_time: 24,
						}
          ],
          fields: [
            {
              name: () => this.$t("b2bName"),
              key: "bill_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("b2bName");
              }
            },
            {
              key: "rate_time",
              name: () => this.$t("rate")+this.$t('date'),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("rate")+this.$t('date'),
              bind: {
                type: "month",
                style: {
                  width: "100%"
                }
              },
              disabledDate: true,
							methods:{
								format({value}) {
								  return this.format.monthFormat(value) || "";
								},
							}
            },
					]
        },
				showDetails: {
				  config: {
				    listFn: "log",
				    modalBind: {
				      width: 80,
				      transfer: true,
				      draggable: true,
				      sticky: true,
				      "reset-drag-position": true,
				      styles: {
				        top: "30px",
				      },
				    },
				    rowBind: {
				      gutter: 16,
				      style: {
				        marginBottom: "20px",
				      },
				    },
				    formBind: {},
				  },
					footer:{
						show:()=>false
					},
				  table: {
				    config: {
				      height: 750,
				    },
				    footer: {
				      show: true,
				    },
				    fields: [
							{
							  name: () => this.$t("operate"),
							  key: "operate_name",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("operation") + this.$t("time"),
							  key: "operate_time",
							  width: 170,
							},
				      {
				        name: () => this.$t("operation") + this.$t("content"),
				        key: "operate_content",
				        minWidth: 100,
								render(h,data){
									return h('div',{domProps: {
											innerHTML: data.row.operate_content // 这里是要渲染的数据
									}})
								}
				      },
				      {
				        name: () => this.$t("operation") + this.$t("type"),
				        key: "type_txt",
				        minWidth: 80,
				      },
							{
							  name: () => this.$t("clientName"),
							  key: "client_name",
							  minWidth: 80,
							},
							
				    ],
				  },
				},
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 1200,
              draggable: true,
              styles: {
                top: "3%"
              }
            },
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;"
            },
            formBind: {
              labelWidth: 140
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              agent_id: [
                {
                  required: true,
                  message: "agent_id cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              currency: [
                {
                  required: true,
                  message: "currency cannot be empty",
                  trigger: "change"
                }
              ],
              title: [
                {
                  required: true,
                  message: "ddp_price cannot be empty",
                  trigger: "blur"
                }
              ],
              start_time: [
                {
                  required: true,
                  message: "ddp_price cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ],
              end_time: [
                {
                  required: true,
                  message: "ddp_price cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [
            {
              name: () => this.$t("basic_information"),
              span: 24,
              children: [
                {
                  title: 8,
                  start_time: 8,
                  end_time: 8
                },
                {
                  agent_id: 8,
                  currency: 8,
                  remarks: 8
                }
              ]
            },
            {
              name: () => this.$t("cost_t") + this.$t("information"),
              span: 24,
              children: [
                {
                  tax_type: 8,
                  tax_fee: 8,
                  tariff_fee: 8
                },
                {
                  clearance_type: 8,
                  clearance_check: 8
                },
                {
                  clearance_fee: 8,
                  clearance_fee_max: 8
                },
                {
                  delivery_type: 8,
                  delivery_fee: 8
                },
                {
                  air_type: 8,
                  air_fee: 8,
                  airport_fee: 8
                },
                {
                  sea_check: 8,
                  sea_fee: 8,
                  sea_fee_max: 8
                },
                {
                  other_fee: 8,
                  transport_fee: 8
                },
                {
                  weight_fee: 8,
                  send_fee: 8
                },
                {
                  vat_fee: 8,
                  vat_data: 8
                },
                {
                  order_fee: 8,
                  order_fee_min: 8
                }
              ]
            },
						
          ],
          fields: [
            {
              name: () => this.$t("costName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("costName");
              }
            },
            {
              key: "start_time",
              name: () => this.$t("enableTime"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("enableTime"),
              bind: {
                clearable: false,
                type: "datetime",
                style: {
                  width: "100%"
                }
              },
              disabledDate: true
            },
            {
              key: "end_time",
              name: () => this.$t("deadline"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("deadline"),
              bind: {
                clearable: false,
                type: "datetime",
                style: {
                  width: "100%"
                }
              },
              disabledDate: true
            },
            {
              name: () => this.$t("agentName"),
              key: "agent_id",
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("agentName");
              },
              options: [],
              optionsList: "agent"
            },
            {
              name: () => this.$t("billingCurrency"),
              key: "currency",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("billingCurrency");
              },
              options: []
            },
            {
              name: () =>
                this.$t("taxFee") + this.$t("collection") + this.$t("type"),
              key: "tax_type",
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("taxFee") +
                  this.$t("collection") +
                  this.$t("type")
                );
              },
              options: []
            },
            {
              name: () => this.$t("taxFee"),
              key: "tax_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("taxFee");
              }
            },
            {
              name: () =>
                this.$t("clearanceFee") +
                this.$t("collection") +
                this.$t("type"),
              key: "clearance_type",
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("clearanceFee") +
                  this.$t("collection") +
                  this.$t("type")
                );
              },
              options: []
            },
            {
              name: () => this.$t("clearanceFee") + this.$t("criticalValue"),
              key: "clearance_check",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              show: ({ row }) =>
                row.clearance_type == 2 || row.clearance_type == 3,
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("clearanceFee") +
                  this.$t("criticalValue")
                );
              }
            },
            {
              name: () => this.$t("clearanceFee"),
              key: "clearance_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("clearanceFee");
              }
            },
            {
              name: () => this.$t("numMax") + this.$t("clearanceFee"),
              key: "clearance_fee_max",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              show: ({ row }) => row.clearance_type == 2,
              default: null,
              placeholder() {
                return (
                  this.$t("enter") + this.$t("numMax") + this.$t("clearanceFee")
                );
              }
            },
            {
              name: () =>
                this.$t("deliveryCost") +
                this.$t("collection") +
                this.$t("type"),
              key: "delivery_type",
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("deliveryCost") +
                  this.$t("collection") +
                  this.$t("type")
                );
              },
              options: []
            },
            {
              name: () => this.$t("deliveryCost"),
              key: "delivery_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("deliveryCost");
              }
            },
            {
              name: () => this.$t("airportCost"),
              key: "airport_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("airportCost");
              }
            },
            {
              name: () =>
                this.$t("airFreight") + this.$t("collection") + this.$t("type"),
              key: "air_type",
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("airFreight") +
                  this.$t("collection") +
                  this.$t("type")
                );
              },
              options: []
            },
            {
              name: () => this.$t("airFreight"),
              key: "air_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("airFreight");
              }
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tariff_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("tax_fee");
              }
            },
            {
              name: () => this.$t("customsFee") + this.$t("criticalValue"),
              key: "sea_check",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("customsFee") +
                  this.$t("criticalValue")
                );
              }
            },
            {
              name: () => this.$t("customsFee"),
              key: "sea_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("customsFee");
              }
            },
            {
              name: () =>
                this.$t("customsFee") + this.$t("numMax") + this.$t("value"),
              key: "sea_fee_max",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("customsFee") +
                  this.$t("numMax") +
                  this.$t("value")
                );
              }
            },
            {
              name: () => this.$t("otherCost"),
              key: "other_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("otherCost");
              }
            },
            {
              name: () => this.$t("transportCost"),
              key: "transport_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("transportCost");
              }
            },
            {
              name: () => this.$t("billWeight"),
              key: "weight_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("billWeight");
              }
            },
            {
              name: () => this.$t("deliveryFee"),
              key: "send_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("deliveryFee");
              }
            },
            {
              name: () => this.$t("VATFee"),
              key: "vat_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("VATFee");
              }
            },
            {
              name: () =>
                this.$t("collection") +
                this.$t("cost_t") +
                this.$t("category_t"),
              key: "vat_data",
              component: "Select",
              bind: {
                multiple: true
              },
              options: [],
              optionsList: "vat_type",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("collection") +
                  this.$t("cost_t") +
                  this.$t("category_t")
                );
              },
              show: ({ row }) => row.vat_fee > 0
            },
            {
              name: () => this.$t("billPackageFee"),
              key: "order_fee",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("billPackageFee");
              }
            },
            {
              name: () => this.$t("billPackageFee") + this.$t("lowCost"),
              key: "order_fee_min",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%"
              },
              default: null,
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("billPackageFee") +
                  this.$t("lowCost")
                );
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            }
          ]
        },
				create_tag:{
					type:'add',
					methods: {
						ok({ row, close }) {
							this.$page
								.handleRequestMethods("create_tag", row, true)
								.then(res => {
									this.$page.getList();
									close();
								});
						}
					},
					config: {
						title:this.$t('MarkAbnormal'),
						modalBind: {
							width: 600,
							draggable: true,
						},
						formBind: {
							labelWidth: 140
						},
						rowBind: {
							gutter: 16,
							style: {
								marginBottom: "20px"
							}
						},
					},
					grid: [
						{
							remarks: 24,
						},
					],
					fields: [
						{
						name: () => this.$t("exception_msg"),
						key: "remarks",
						component: "Input",
						bind: {
							type: "textarea",
							rows: 4
						},
						placeholder() {
							return this.$t("enter") + this.$t("exception_msg");
						}
						}
					]
				},
				clearance_fee:{
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("clearance_fee", row, true)
                .then(async (res) => {
                  close();
                });
            },
          },
          config: {
						title:this.$t('clearanceFee')+this.$t('Sync'),
            modalBind: {
              width: 500,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              extract_number: [
                {
                  required: true,
                  message: "Please select the country",
                  trigger: "change",
                  type: "string",
                },
              ],
            },
          },
          grid: [{ extract_number: 24 }],
          fields: [
            {
              name: () => this.$t("mawb"),
              key: "extract_number",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 5 },
              },
              placeholder() {
                return this.$t("enter") + this.$t("mawb");
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "agent_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            clearable: true,
            options: [],
						config: { label: "agent_name", value: "id" },
						methods:{
							list({field}){
								getAgent().then(res=>{
									if(res.data.status){
										field.options = res.data.payload.rows
									}
								})
							}
						}
          },
					{
					  key: "client_id",
					  placeholder() {
					    return this.$t("select") + this.$t("clientName");
					  },
					  component: "Select",
					  config: {
					    value: "id",
					    label: "account",
					  },
					  methods: {
					    async list({ field }) {
					      field.options = (
					        await this.$page.handleRequestMethods("getAllClient")
					      ).payload.rows;
					      this.$forceUpdate();
					    },
					  },
					},
					{
						key: "classify_id",
						placeholder() {
							return this.$t("select") + this.$t("costCategories");
						},
						component: "Select",
						options: [],
						methods: {
							async list({ field, searchForm }) {
								this.$page.handleRequestMethods('cost_classify').then(res=>{
									field.options = res.payload
									this.$forceUpdate();
								})
							},
							'on-change'({ fields, searchForm }){
									fields.forEach(field=>{
										if(field.key === 'expense_item'){
											this.handleRequestMethods('cost_expense_item',{pid:searchForm.classify_id}).then(res=>{
												field.options = res.payload
												this.$forceUpdate();
											})
										}
									})
							}
						}
					},
					{
						key: "expense_item",
						placeholder() {
							return this.$t("select") + this.$t("costSuject");
						},
						component: "Select",
						options: [],
						methods: {
							async list({ field, searchForm }) {
								this.$page.handleRequestMethods('cost_expense_item').then(res=>{
									field.options = res.payload
									this.$forceUpdate();
								})
							}
						}
					},
					{
						key: "keywordsType",
						placeholder() {
							return this.$t("select") + this.$t("keywords_type");
						},
						clearable: false,
						component: "Select",
						options: [],
						methods: {
							async list({ field, searchForm }) {
								let res = (await getSelectType(["EXTRACT_KEYWORDS_TYPE"])).data
									.payload["EXTRACT_KEYWORDS_TYPE"];
								field.options = res;	
								searchForm[field.key] = res[0].value
								this.$forceUpdate();
							}
						}
					},
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 907
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
						{
						  name: () => this.$t("createBill"),
						  type: "createBill",
						  fnName: "createBill",
						  bind: {
						    icon: "md-add",
						    type: "warning",
						  },
						  id: 1244,
						},
						{
						  name: () => this.$t("createDeliveryBill"),
						  type: "createDeliveryBill",
						  fnName: "createDeliveryBill",
						  bind: {
						    icon: "md-add",
						    type: "warning",
						  },
						  id: 1247,
						},
						{
						  name: () => this.$t("clearanceFee")+this.$t('Sync'),
						  type: "clearanceFee",
						  fnName: "clearanceFee",
						  bind: {
						    icon: "md-add",
						    type: "warning",
						  },
						  id: 1247,
						},
						{
						  name: () => this.$t("MarkAbnormal"),
						  type: "MarkAbnormal",
						  fnName: "MarkAbnormal",
							disabled() {
							  return !this.selectAll.length;
							},
						  bind: {
						    icon: "md-add",
						    type: "warning",
						  },
						  id: 1281,
						},
						{
						  name: () => this.$t("BillPreview"),
						  type: "BillPreview",
						  fnName: "BillPreview",
						  bind: {
						    type: "primary",
						  },
						},
          ],
          methods: {
						BillPreview({searchForm}){
							this.handleRequestMethods('preview',searchForm,false,true).then(res=>{
								console.log(res);
								window.open(this.$globalUrl+res.payload.src)
							})
						},
						MarkAbnormal(){
							this.getModal('create_tag').open({ids:this.selectAll.map(t=>t.id)})
						},
						clearanceFee(){
							this.getModal('clearance_fee').open()
						},
						createDeliveryBill(){
							this.getModal('createDeliveryBill').open()
						},
						createBill({ searchForm }) {
							let ids = this.selectAll.map(t=>t.id)
							this.getModal('createBill').open({...searchForm,ids})
						},
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, function() {
                this.list = [
                  {
                    lower_weight: "",
                    upper_weight: "",
                    price: "",
                    weight: ""
                  }
                ];
                this.setTitle(this.$t("add"));
                this.type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
				{
					name: () => this.$t("mawb"),
					key:'extract',
					align: "center",
					minWidth: 130
				},
				{
				  name: () => this.$t("BillingNumber"),
				  key: "number",
				  align: "center",
				  minWidth: 150
				},
				{
				  name: () => this.$t("bill_number"),
				  key: "bill_number",
				  align: "center",
				  minWidth: 150,
					component:'a',
					methods:{
						click({row}){
							this.$refs['xTable'].closeTooltip()
							this.$router.push({
							  name: "cost_bill"
							});
							this.$store.dispatch("pageUrl", row.bill_number);
						}
					}
				},
				{
				  name: () => this.$t("agentName"),
				  key: "agent_name",
				  align: "center",
				  minWidth: 120
				},
        {
          name: () => this.$t("costCategories"),
          key: "classify_id",
          align: "center",
          minWidth: 120
        },
				{
				  name: () => this.$t("costSuject"),
				  key: "expense_item",
				  align: "center",
				  minWidth: 120
				},
				{
				  name: () => this.$t("currency_t"),
				  key: "currency",
				  align: "center",
				  minWidth: 100
				},
				
				{
				  name: () => this.$t("quantity1"),
				  key: "charging_value",
				  align: "center",
				  minWidth: 120
				},
				{
				  name: () => this.$t("doublePrice"),
				  key: "price",
				  align: "center",
				  minWidth: 100
				},
				{
				  name: () => this.$t("finalCost") + this.$t("reChAmount"),
				  key: "amount",
				  align: "center",
				  minWidth: 120
				},
				{
				  name: () => this.$t("createUser"),
				  key: "create_name",
				  align: "center",
				  minWidth: 100
				},
				{
				  name: () => this.$t("createTime"),
				  key: "create_time",
				  align: "center",
				  minWidth: 160
				},
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 906
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error"
              },
              id: 905
            },
						{
						  name: this.$t("updateLog"),
						  type: "log",
						  fnName: "log",
						  bind: {
						    type: "primary"
						  },
							id:1043
						}
          ],
          methods: {
						log({row}){
							this
							  .getModal("showDetails")
							  .setTitle(this.$t("detail"));
							this.getModal("showDetails").open({ row }, function () {
							  let data = {
							    relation_id: row.id,
									type:8
							  };
							  this.pageConfig.data = data;
							  this.getList(data);
							});
						},
            update({ row }) {
              this.getModal("add").open(row, function() {
                this.setTitle(this.$t("update"));
              });
              // });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id, true).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  async mounted() {
  }
};
</script>
